import * as React from "react";
import { GoogleMap, Marker, DirectionsRenderer, withGoogleMap } from "react-google-maps";
import { compose, withProps } from "recompose";
import { Client } from "src/api/model";

export interface VisitsDetail {
    id?: number;
    client: Client | undefined;
    location: Dot;
    visitDateTime: string | undefined;
    observations?: string;
    order?: number;
    street1?: string;
    type?: string;
    amount?: number;
}

export class Dot {
    lat: number;
    lng: number;

    constructor(latitude: number, longitude: number) {
        this.lat = latitude;
        this.lng = longitude;
    }
}

export interface LocationData {
    id: number;
    lat: number;
    lng: number;
  
    street1: string;
    client: {
      user: { name: string; email: string };
      phone: string;
    };
}

interface MapProps {
    zoom: number;
    center: Dot;
    origin?: Dot;
    destiny?: any;
    directions: any;
    handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;
    handleDragEnd(whichOne: string, index?: number, type?: string): (e: google.maps.MouseEvent) => void;
}

export type MarkerType = "origin" | "destiny";

class EnhancedMap extends React.Component<MapProps> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const { center, zoom, destiny, handleDragEnd, directions } = this.props;
        return (
            <GoogleMap defaultZoom={zoom} center={center} onClick={this.props.handleOnClick}>
                {/* {
                    origin &&
                    <Marker draggable
                        onDragEnd={handleDragEnd('origin')}
                        position={origin}
                        label={{ text: "O", color: "white" }}
                    />
                } */}
                {destiny &&
                    destiny.length > 0 &&
                    destiny.map((item: VisitsDetail, index: number) => (
                        // item.order !== 1 && (
                        <Marker
                            draggable
                            onDragEnd={handleDragEnd("destiny", index, item.order && item.order === 1 ? 'O' : 'V')}
                            position={item.location}
                            label={{ text: item.order && item.order === 1 ? 'O' : 'V' + item.order, color: "white" }}
                            key={index}
                        />
                        // )
                    ))}

                {directions && (
                    <DirectionsRenderer
                        directions={directions}
                        defaultOptions={{ suppressMarkers: true }}
                    />
                )}
            </GoogleMap>
        );
    }
}

export default compose<MapProps, MapProps>(
    withProps({
        containerElement: <div style={{ height: '400px' }} />,
        mapElement: <div style={{ height: '400px' }} />,
    }),
    withGoogleMap
)(EnhancedMap);


// WEBPACK FOOTER //
// ./src/components/enhancedMap.tsx